// Browser tabs show roughly the first 15-20 characters, so the distinctive words have to
// come first and the whole thing has to stay short. Pages keep their longer descriptive
// titles for search results and link previews; this is only what the tab shows.
const MAX = 24;
// Words that read as dangling when a title is cut after them.
const TRAILING = /\s+(?:&|and|or|for|with|in|on|to|the|a|an|your|across|of|from|that|by)$/i;

export const shortenTitle = (raw: string): string => {
  const title = (raw || "").replace(/\s+/g, " ").trim();
  if (!title) return "ClearMakes";

  // Take the part before the first separator: that is the page's own name.
  let head = title.split(/\s+[|·—–]\s+/)[0].trim().replace(/[.,;:]+$/, "");
  if (/^ClearMakes$/i.test(head)) return "ClearMakes";

  // Trim to whole words so nothing is cut mid-phrase.
  if (head.length > MAX) {
    const cut = head.slice(0, MAX);
    const space = cut.lastIndexOf(" ");
    head = (space > 10 ? cut.slice(0, space) : cut).replace(/[\s&|,\-–—]+$/, "");
    while (TRAILING.test(head)) head = head.replace(TRAILING, "");
  }

  return /clearmakes/i.test(head) ? head : `${head} · ClearMakes`;
};
